<template>
  <div class="route-form-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
        <h2 class="page-title">{{ pageTitle }}</h2>
      </div>
      <div class="header-right">
        <template v-if="pageType !== '3'">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleSubmit"> 保存 </el-button>
        </template>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 左侧表单 -->
      <div class="form-section">
        <el-form
          :model="formData"
          :rules="rules"
          ref="routeForm"
          label-width="160px"
          :scroll-to-error="false"
        >
          <!-- 基本信息 -->
          <div class="section-card">
            <div class="section-title">
              <i class="el-icon-circle-check"></i>
              基本信息
            </div>

            <el-form-item label="线路全名" required prop="productName">
              <el-input
                v-model="formData.productName"
                placeholder="例如：虎跳峡高路徒步两日游"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>

            <el-form-item label="线路难度" required prop="difficulty">
              <el-select
                v-model="formData.difficulty"
                placeholder="请选择线路难度"
                :disabled="isDetail"
                style="width: 400px"
              >
                <el-option
                  label="简单（适合新手，路况良好）"
                  :value="1"
                ></el-option>
                <el-option
                  label="一般（需要一定体力，有部分挑战路段）"
                  :value="2"
                ></el-option>
                <el-option
                  label="困难（需要丰富经验，路况复杂）"
                  :value="3"
                ></el-option>
              </el-select>
            </el-form-item>

            <div class="form-row">
              <el-form-item label="基础价格 (元)" required prop="basePrice">
                <el-input-number
                  v-model="formData.basePrice"
                  :min="0"
                  :precision="2"
                  :disabled="isDetail"
                ></el-input-number>
              </el-form-item>
              <el-form-item
                label="徒步总里程 (公里)"
                required
                prop="totalDistance"
              >
                <el-input-number
                  v-model="formData.totalDistance"
                  :min="0"
                  :precision="1"
                  :disabled="isDetail"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="爬升高度 (米)" required prop="maxAltitude">
                <el-input-number
                  v-model="formData.maxAltitude"
                  :min="0"
                  :disabled="isDetail"
                ></el-input-number>
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item label="总天数" required prop="totalDays">
                <el-input-number
                  v-model="formData.totalDays"
                  :min="1"
                  :disabled="isDetail"
                ></el-input-number>
              </el-form-item>
              <el-form-item
                label="单日最长用时 (小时)"
                required
                prop="maxDailyHours"
              >
                <el-input-number
                  v-model="formData.maxDailyHours"
                  :min="0"
                  :max="24"
                  :precision="1"
                  :disabled="isDetail"
                ></el-input-number>
              </el-form-item>
              <el-form-item
                label="单程车程时间 (小时)"
                required
                prop="oneWayDriveTime"
              >
                <el-input-number
                  v-model="formData.oneWayDriveTime"
                  :min="0"
                  :precision="1"
                  :disabled="isDetail"
                ></el-input-number>
              </el-form-item>
              <el-form-item
                label="全额退款节点 (天)"
                required
                prop="refundDays"
              >
                <el-input-number
                  v-model="formData.refundDays"
                  :min="1"
                  :disabled="isDetail"
                ></el-input-number>
              </el-form-item>
            </div>
          </div>

          <!-- 出发地与目的地 -->
          <div class="section-card">
            <div class="section-title">
              <i class="el-icon-location"></i>
              出发地与目的地
            </div>

            <el-form-item label="出发地" required>
              <div class="form-row">
                <el-form-item prop="startProvince">
                  <el-select
                    v-model="formData.startProvince"
                    placeholder="选择省"
                    :disabled="isDetail"
                    @change="handleStartProvinceChange"
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in provinceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="startCity">
                  <el-select
                    v-model="formData.startCity"
                    placeholder="选择市"
                    :disabled="isDetail || !formData.startProvince"
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in startCityList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="startDistrict" required>
                  <el-input
                    v-model="formData.startDistrict"
                    placeholder="区（如：古城区）"
                    :disabled="isDetail"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>

            <el-form-item label="目的地" required>
              <div class="form-row">
                <el-form-item prop="destProvince">
                  <el-select
                    v-model="formData.destProvince"
                    placeholder="选择省"
                    :disabled="isDetail"
                    @change="handleDestProvinceChange"
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in provinceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="destCity">
                  <el-select
                    v-model="formData.destCity"
                    placeholder="选择市"
                    :disabled="isDetail || !formData.destProvince"
                    @change="handleDestCityChange"
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in destCityList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="destDistrict" required>
                  <el-input
                    v-model="formData.destDistrict"
                    placeholder="区（如：香格里拉市）"
                    :disabled="isDetail"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
          </div>

          <!-- 线路展示图 -->
          <div class="section-card">
            <div class="section-title">
              <i class="el-icon-picture"></i>
              线路展示图
            </div>

            <el-upload
              v-if="!isDetail"
              class="image-uploader"
              :action="uploadAction"
              :auto-upload="true"
              :show-file-list="true"
              :on-change="handleImageChange"
              :on-success="handleImageSuccess"
              :on-remove="handleImageRemove"
              :on-preview="handlePictureCardPreview"
              :before-upload="beforeUpload"
              :file-list="imageFileList"
              list-type="picture-card"
              accept="image/jpeg,image/jpg,image/png,video/mp4"
              :headers="uploadHeaders"
              name="files"
            >
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img
                  v-if="isImageFile(file)"
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                  @click.stop="handlePictureCardPreview(file)"
                  style="cursor: pointer"
                />
                <video
                  v-else
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  @click.stop="handlePictureCardPreview(file)"
                  style="cursor: pointer"
                ></video>
                <span
                  v-if="!isDetail"
                  class="custom-delete-btn"
                  @click.stop="handleImageRemove(file, imageFileList)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </div>
            </el-upload>
            <div v-if="isDetail" class="image-preview-list">
              <div
                v-for="(img, index) in formData.imageList"
                :key="index"
                class="preview-item"
                @click="handleDetailImagePreview(img)"
              >
                <el-image
                  v-if="isImageFile(img)"
                  :src="img.imageUrl || img"
                  fit="cover"
                  class="preview-image"
                  lazy
                ></el-image>
                <video
                  v-else
                  :src="img.imageUrl || img"
                  class="preview-video"
                  muted
                ></video>
              </div>
            </div>
            <p class="upload-tip">
              支持JPG/JPEG/PNG格式图片及MP4格式视频，图片建议比例4:3，图片建议大小不超过10MB，视频建议大小不超过100MB
            </p>
          </div>

          <!-- 出发日期价格管理 -->
          <div class="section-card">
            <div class="section-header">
              <div class="section-title">
                <i class="el-icon-date"></i>
                出发日期价格管理
              </div>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click="handleBatchImport"
                :disabled="isDetail"
              >
                批量导入日期
              </el-button>
            </div>

            <div class="calendar-container">
              <!-- 日历头部 -->
              <div class="calendar-header">
                <el-button
                  type="text"
                  icon="el-icon-arrow-left"
                  @click="prevMonth"
                  :disabled="isDetail"
                ></el-button>
                <span class="current-month"
                  >{{ currentYear }}年{{ currentMonth }}月</span
                >
                <el-button
                  type="text"
                  icon="el-icon-arrow-right"
                  @click="nextMonth"
                  :disabled="isDetail"
                ></el-button>
              </div>

              <!-- 星期标题 -->
              <div class="week-header">
                <div class="week-day">周一</div>
                <div class="week-day">周二</div>
                <div class="week-day">周三</div>
                <div class="week-day">周四</div>
                <div class="week-day">周五</div>
                <div class="week-day">周六</div>
                <div class="week-day">周日</div>
              </div>

              <!-- 日历网格 -->
              <div class="calendar-grid">
                <div
                  v-for="(day, index) in calendarDays"
                  :key="index"
                  class="calendar-day"
                  :class="{
                    'other-month': !day.isCurrentMonth,
                    'has-price': day.hasPrice && day.isCurrentMonth,
                    today: day.isToday,
                    'past-date': day.isPast && day.isCurrentMonth
                  }"
                  @click="handleDayClick(day)"
                >
                  <div class="day-number">{{ day.day }}</div>
                  <div
                    class="day-price"
                    v-if="day.hasPrice && day.isCurrentMonth"
                  >
                    ¥{{ day.price }}
                  </div>
                  <div
                    class="day-group-info"
                    v-if="day.hasPrice && day.isCurrentMonth"
                  >
                    <span>{{ day.minGroupSize }}-{{ day.maxGroupSize }}人</span>
                  </div>
                  <!-- 删除图标 - 只在有价格的日期显示 -->
                  <div
                    v-if="day.hasPrice && day.isCurrentMonth && !isDetail"
                    class="day-delete-icon"
                    @click.stop="handleDeleteDeparture(day)"
                    title="删除该日期"
                  >
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </div>

              <div class="calendar-legend">
                <span class="legend-item">
                  <span class="legend-dot has-price"></span>
                  已设置排期
                </span>
              </div>
            </div>
          </div>

          <!-- 日期编辑弹窗 -->
          <el-dialog
            :title="isDetail ? '日期详情' : '设置日期价格'"
            :visible.sync="dateDialogVisible"
            width="500px"
            :close-on-click-modal="false"
          >
            <el-form
              ref="dateForm"
              :model="currentDateData"
              :rules="isDetail ? {} : dateFormRules"
              label-width="120px"
            >
              <el-form-item label="出发日期" prop="departureDate">
                <el-date-picker
                  v-model="currentDateData.departureDate"
                  type="date"
                  placeholder="选择出发日期"
                  value-format="yyyy-MM-dd"
                  :disabled="isDetail || isEditMode"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="出发时间" prop="departureTime">
                <el-time-picker
                  v-model="currentDateData.departureTime"
                  placeholder="选择出发时间"
                  value-format="HH:mm:ss"
                  :disabled="isDetail"
                  style="width: 100%"
                >
                </el-time-picker>
              </el-form-item>
              <el-form-item label="该日价格 (元)">
                <el-input-number
                  v-model="currentDateData.price"
                  :min="0"
                  :precision="2"
                  :disabled="isDetail"
                  style="width: 100%"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="最小成团人数">
                <el-input-number
                  v-model="currentDateData.minGroupSize"
                  :min="1"
                  :disabled="isDetail"
                  style="width: 100%"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="最大成团人数">
                <el-input-number
                  v-model="currentDateData.maxGroupSize"
                  :min="1"
                  :disabled="isDetail"
                  style="width: 100%"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="成团截至时间">
                <el-date-picker
                  v-model="currentDateData.cancelDeadline"
                  type="datetime"
                  placeholder="选择成团截至时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :disabled="isDetail"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="报名截止时间">
                <el-date-picker
                  v-model="currentDateData.registrationDeadline"
                  type="datetime"
                  placeholder="选择报名截止时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :disabled="isDetail"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dateDialogVisible = false">
                {{ isDetail ? '关 闭' : '取 消' }}
              </el-button>
              <el-button
                v-if="!isDetail"
                type="primary"
                @click="handleSaveDate"
              >
                确 定
              </el-button>
            </span>
          </el-dialog>

          <!-- 批量导入弹窗 -->
          <el-dialog
            title="批量导入日期"
            :visible.sync="batchImportVisible"
            width="500px"
          >
            <el-form
              ref="batchForm"
              :model="batchFormData"
              :rules="batchFormRules"
              label-width="120px"
            >
              <el-form-item label="开始日期" prop="startDate">
                <el-date-picker
                  v-model="batchStartDate"
                  type="date"
                  placeholder="选择开始日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期" prop="endDate">
                <el-date-picker
                  v-model="batchEndDate"
                  type="date"
                  placeholder="选择结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="出发时间" prop="departureTime">
                <el-time-picker
                  v-model="batchDepartureTime"
                  placeholder="选择出发时间"
                  value-format="HH:mm:ss"
                  style="width: 100%"
                >
                </el-time-picker>
              </el-form-item>
              <el-form-item label="统一价格 (元)" prop="price">
                <el-input-number
                  v-model="batchPrice"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="最小成团人数" prop="minGroupSize">
                <el-input-number
                  v-model="batchMinGroupSize"
                  :min="1"
                  style="width: 100%"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="最大成团人数" prop="maxGroupSize">
                <el-input-number
                  v-model="batchMaxGroupSize"
                  :min="1"
                  style="width: 100%"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="成团截至时间" prop="cancelDeadline">
                <el-date-picker
                  v-model="batchCancelDeadline"
                  type="datetime"
                  placeholder="选择成团截至时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="getBatchDeadlinePickerOptions()"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="报名截止时间" prop="registrationDeadline">
                <el-date-picker
                  v-model="batchRegistrationDeadline"
                  type="datetime"
                  placeholder="选择报名截止时间时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="getBatchDeadlinePickerOptions()"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="batchImportVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleBatchSave"
                >批量添加</el-button
              >
            </span>
          </el-dialog>

          <!-- 产品详情介绍 -->
          <div class="section-card">
            <div class="section-title">
              <i class="el-icon-document"></i>
              产品详情介绍
            </div>

            <div class="editor-content" :class="{ 'is-disabled': isDetail }">
              <quill-editor
                v-if="editorLoaded"
                ref="quillEditor"
                v-model="formData.detailContent"
                :options="editorOption"
                :disabled="isDetail"
                @focus="onEditorFocus"
              ></quill-editor>
            </div>
          </div>
        </el-form>
      </div>

      <!-- 图片/视频预览对话框 -->
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img
          v-if="isImageFile(dialogFile || dialogImageUrl)"
          width="100%"
          :src="dialogImageUrl"
          alt=""
        />
        <video
          v-else
          :src="dialogImageUrl"
          controls
          style="width: 100%"
        ></video>
      </el-dialog>

      <!-- 右侧边栏 -->
      <div class="sidebar-section">
        <!-- 推荐人群 -->
        <div class="sidebar-card">
          <div class="sidebar-title">
            <i class="el-icon-user"></i>
            推荐人群
          </div>
          <el-input
            type="textarea"
            v-model="formData.recommendedPeople"
            :rows="4"
            placeholder="例如：适合有一定徒步经验的户外爱好者，年龄18-60岁"
            :disabled="isDetail"
          ></el-input>
          <div class="field-tip">支持逗号、顿号、空格分隔多个人群</div>
        </div>

        <!-- 注意事项 -->
        <div class="sidebar-card">
          <div class="sidebar-title">
            <i class="el-icon-warning"></i>
            注意事项
          </div>
          <el-input
            type="textarea"
            v-model="formData.notice"
            :rows="4"
            placeholder="例如：1.请穿着舒适的徒步鞋 2.携带足够的饮用水 3.注意防晒和保暖"
            :disabled="isDetail"
          ></el-input>
        </div>

        <!-- 免责条款 -->
        <div class="sidebar-card">
          <div class="sidebar-title">
            <i class="el-icon-info"></i>
            免责条款
          </div>
          <el-input
            type="textarea"
            v-model="formData.disclaimer"
            :rows="4"
            placeholder="例如：参与者需自行承担户外活动风险，组织者已尽到安全提示义务"
            :disabled="isDetail"
          ></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RouteForm',
  data() {
    return {
      pageType: '1',
      productId: null,
      // 图片预览
      dialogImageUrl: '',
      dialogVisible: false,
      dialogFile: null, // 保存当前预览的文件对象
      imageFileList: [],
      // 上传相关配置
      uploadHeaders: {
        Authorization: localStorage.getItem('token') || ''
      },
      // 上传地址（两个环境都使用 /xunshanke-server 前缀）
      uploadAction: '/xunshanke-server/file/uploadProdImage.do',
      provinceList: [],
      startCityList: [],
      destCityList: [],
      // 日历相关
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      calendarDays: [],
      // 日期编辑弹窗
      dateDialogVisible: false,
      isEditMode: false, // 是否是编辑已有日期
      currentDateData: {
        departureDate: '',
        price: 0,
        minGroupSize: '',
        maxGroupSize: '',
        cancelDeadline: '',
        registrationDeadline: ''
      },
      // 单个日期表单验证规则
      dateFormRules: {
        departureDate: [
          { required: true, message: '请选择出发日期', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { type: 'number', min: 0, message: '价格不能低于0', trigger: 'blur' }
        ],
        minGroupSize: [
          { required: true, message: '请输入最小成团人数', trigger: 'blur' }
        ],
        maxGroupSize: [
          { required: true, message: '请输入最大成团人数', trigger: 'blur' }
        ],
        cancelDeadline: [
          { required: true, message: '请选择截至时间', trigger: 'change' }
        ],
        registrationDeadline: [
          {
            required: true,
            message: '请选择报名截止时间',
            trigger: 'change'
          }
        ]
      },
      // 批量导入弹窗
      batchImportVisible: false,
      batchStartDate: '',
      batchEndDate: '',
      batchDepartureTime: '',
      batchPrice: '',
      batchMinGroupSize: '',
      batchMaxGroupSize: '',
      batchCancelDeadline: '',
      batchRegistrationDeadline: '',
      // 批量导入表单数据对象（用于表单验证）
      batchFormData: {
        startDate: '',
        endDate: '',
        departureTime: '',
        price: '',
        minGroupSize: '',
        maxGroupSize: '',
        cancelDeadline: '',
        registrationDeadline: ''
      },
      // 批量导入表单验证规则
      batchFormRules: {
        startDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ],
        price: [{ required: true, message: '请输入统一价格', trigger: 'blur' }],
        minGroupSize: [
          { required: true, message: '请输入最小成团人数', trigger: 'blur' }
        ],
        maxGroupSize: [
          { required: true, message: '请输入最大成团人数', trigger: 'blur' }
        ],
        cancelDeadline: [
          { required: true, message: '请选择截至时间', trigger: 'change' }
        ],
        registrationDeadline: [
          {
            required: true,
            message: '请选择报名截止时间',
            trigger: 'change'
          }
        ]
      },
      // 富文本编辑器配置
      editorLoaded: false,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ['image'],
              ['clean']
            ],
            handlers: {
              image: this.imageHandler
            }
          }
        },
        placeholder: '请输入产品详情介绍...',
        theme: 'snow',
        // 禁用自动聚焦
        readOnly: false
      },
      formData: {
        id: null,
        productName: '',
        difficulty: '',
        basePrice: '',
        totalDistance: '',
        maxAltitude: '',
        totalDays: '',
        maxDailyHours: '',
        oneWayDriveTime: '',
        startProvince: '',
        startCity: '',
        startDistrict: '',
        destProvince: '',
        destCity: '',
        destDistrict: '',
        refundDays: '',
        recommendedPeople: '',
        notice: '',
        disclaimer: '',
        detailContent: '',
        imageList: [],
        departureList: []
      },
      rules: {
        productName: [
          { required: true, message: '请输入线路全名', trigger: 'blur' }
        ],
        difficulty: [
          { required: true, message: '请选择线路难度', trigger: 'change' }
        ],
        basePrice: [
          { required: true, message: '请输入基础价格', trigger: 'blur' }
        ],
        totalDistance: [
          { required: true, message: '请输入徒步总里程', trigger: 'blur' }
        ],
        maxAltitude: [
          { required: true, message: '请输入爬升高度', trigger: 'blur' }
        ],
        totalDays: [
          { required: true, message: '请输入总天数', trigger: 'blur' }
        ],
        maxDailyHours: [
          { required: true, message: '请输入单日最长用时', trigger: 'blur' }
        ],
        oneWayDriveTime: [
          { required: true, message: '请输入单程车程时间', trigger: 'blur' }
        ],
        startProvince: [
          { required: true, message: '请输入出发地省', trigger: 'blur' }
        ],
        startCity: [
          { required: true, message: '请输入出发地市', trigger: 'blur' }
        ],
        startDistrict: [
          { required: true, message: '请输入出发地区', trigger: 'blur' }
        ],
        destProvince: [
          { required: true, message: '请输入目的地省', trigger: 'blur' }
        ],
        destCity: [
          { required: true, message: '请输入目的城市', trigger: 'blur' }
        ],
        destDistrict: [
          { required: true, message: '请输入目的地区', trigger: 'blur' }
        ],
        refundDays: [
          { required: true, message: '请输入全额退款节点', trigger: 'blur' },
          {
            type: 'number',
            min: 1,
            message: '全额退款节点必须大于1天',
            trigger: 'blur'
          }
        ],
        recommendedPeople: [
          { required: true, message: '请输入推荐人群', trigger: 'blur' }
        ],
        notice: [
          { required: true, message: '请输入注意事项', trigger: 'blur' }
        ],
        disclaimer: [
          { required: true, message: '请输入免责条款', trigger: 'blur' }
        ],
        detailContent: [
          { required: true, message: '请输入线路详情介绍', trigger: 'blur' }
        ],
        imageList: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请上传至少一张线路展示图'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        departureList: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请至少设置一个出发日期'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    isDetail() {
      return this.pageType === '3'
    },
    pageTitle() {
      const titles = {
        1: '线路新增',
        2: '线路修改',
        3: '线路详情'
      }
      return titles[this.pageType] || '线路管理'
    }
  },
  created() {
    this.pageType = this.$route.query.type || '1'
    this.productId = this.$route.query.productId || null

    // 加载省份列表
    this.loadProvinceList()

    if (this.pageType === '2' || this.pageType === '3') {
      this.loadRouteData()
    }

    // 初始化日历
    this.generateCalendar()
  },
  mounted() {
    // 禁用富文本编辑器自动聚焦，防止页面滚动
    // 延迟加载编辑器，避免页面加载时自动聚焦
    setTimeout(() => {
      this.editorLoaded = true
      this.$nextTick(() => {
        const editor = document.querySelector('.ql-editor')
        if (editor) {
          // 设置 tabindex 为 -1 防止获得焦点
          editor.setAttribute('tabindex', '-1')

          // 立即取消焦点
          editor.blur()

          // 锁定滚动位置
          window.scrollTo(window.scrollX, window.scrollY)
        }
      })
    }, 300)
  },
  methods: {
    // 时间戳格式化工具方法
    formatTimestamp(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 时间戳转日期格式 (YYYY-MM-DD)
    formatDateFromTimestamp(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 日期截止时间选择器配置（限制不能晚于出发日期）
    getDeadlinePickerOptions(departureDate) {
      if (!departureDate) return {}

      const departureDateTime = new Date(departureDate).getTime()

      return {
        disabledDate(time) {
          return time.getTime() > departureDateTime
        }
      }
    },

    // 批量导入时截止日期选择器配置（限制不能晚于批量导入的结束日期）
    getBatchDeadlinePickerOptions() {
      if (!this.batchEndDate) return {}

      const endDateTime = new Date(this.batchEndDate).getTime()

      return {
        disabledDate(time) {
          return time.getTime() > endDateTime
        }
      }
    },

    // 日历相关方法
    generateCalendar() {
      const days = []
      const firstDay = new Date(this.currentYear, this.currentMonth - 1, 1)
      const lastDay = new Date(this.currentYear, this.currentMonth, 0)
      const today = new Date()
      today.setHours(0, 0, 0, 0) // 将时间设为0点，便于比较

      // 计算第一天是星期几（周一为0）
      let startDay = firstDay.getDay() - 1
      if (startDay < 0) startDay = 6

      // 添加上月的日期
      const prevMonthLastDay = new Date(
        this.currentYear,
        this.currentMonth - 1,
        0
      ).getDate()
      for (let i = startDay - 1; i >= 0; i--) {
        days.push({
          day: prevMonthLastDay - i,
          isCurrentMonth: false,
          hasPrice: false,
          isPast: false,
          price: '',
          minGroupSize: '',
          maxGroupSize: '',
          date: ''
        })
      }

      // 添加本月的日期
      for (let day = 1; day <= lastDay.getDate(); day++) {
        const dateStr = `${this.currentYear}-${String(
          this.currentMonth
        ).padStart(2, '0')}-${String(day).padStart(2, '0')}`
        const currentDate = new Date(
          this.currentYear,
          this.currentMonth - 1,
          day
        )
        currentDate.setHours(0, 0, 0, 0)
        const isToday = today.getTime() === currentDate.getTime()
        const isPast = currentDate.getTime() < today.getTime() // 判断是否为过去日期

        // 查找该日期是否已设置价格
        const existingDate = this.formData.departureList.find(
          (d) => d.departureDate === dateStr
        )

        days.push({
          day,
          isCurrentMonth: true,
          isToday,
          isPast, // 标记是否为过去日期
          hasPrice: !!existingDate,
          price: existingDate ? existingDate.price : 0,
          minGroupSize: existingDate ? existingDate.minGroupSize : 0,
          maxGroupSize: existingDate ? existingDate.maxGroupSize : 0,
          date: dateStr
        })
      }

      // 添加下月的日期补齐网格
      const remainingDays = 42 - days.length // 6行 x 7列 = 42
      for (let i = 1; i <= remainingDays; i++) {
        days.push({
          day: i,
          isCurrentMonth: false,
          hasPrice: false,
          isPast: false,
          price: '',
          minGroupSize: '',
          maxGroupSize: '',
          date: ''
        })
      }

      this.calendarDays = days
    },

    prevMonth() {
      if (this.currentMonth === 1) {
        this.currentMonth = 12
        this.currentYear--
      } else {
        this.currentMonth--
      }
      this.generateCalendar()
    },

    nextMonth() {
      if (this.currentMonth === 12) {
        this.currentMonth = 1
        this.currentYear++
      } else {
        this.currentMonth++
      }
      this.generateCalendar()
    },

    handleDayClick(day) {
      // 不允许点击非本月日期或过去日期
      if (!day.isCurrentMonth || day.isPast) {
        if (day.isPast) {
          this.$message.warning('不能修改今天之前的日期')
        }
        return
      }

      // 查找是否已存在该日期
      const existingDate = this.formData.departureList.find(
        (d) => d.departureDate === day.date
      )

      if (existingDate) {
        // 编辑已有日期
        this.isEditMode = true
        this.currentDateData = { ...existingDate }
      } else {
        // 新建日期 - 使用字符串格式
        this.isEditMode = false
        this.currentDateData = {
          departureDate: day.date,
          departureTime: '00:00:00',
          price: '',
          minGroupSize: '',
          maxGroupSize: '',
          cancelDeadline: '',
          registrationDeadline: ''
        }
      }

      this.dateDialogVisible = true
    },

    /**
     * 删除日历上的日期
     * @param {Object} day - 日历日期对象
     */
    async handleDeleteDeparture(day) {
      // 查找对应的日期数据
      const existingDate = this.formData.departureList.find(
        (d) => d.departureDate === day.date
      )

      if (!existingDate) {
        this.$message.warning('未找到该日期数据')
        return
      }

      // 确认删除
      try {
        await this.$confirm('确定要删除该日期的排期吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }

      try {
        // 调用后端删除接口
        const response = await this.$http.post('/product/deleteDeparture.do', {
          departureId: existingDate.id
        })

        if (response.code === '0' || response.code === 0) {
          // 从本地列表中移除
          const index = this.formData.departureList.findIndex(
            (d) => d.departureDate === day.date
          )
          if (index >= 0) {
            this.formData.departureList.splice(index, 1)
          }

          // 重新生成日历
          this.generateCalendar()
          this.$message.success('删除成功')
        } else {
          this.$message.error(response.message || '删除失败')
        }
      } catch (error) {
        console.error('删除日期失败:', error)
        this.$message.error('删除失败，请重试')
      }
    },

    handleSaveDate() {
      // 使用表单验证
      this.$refs.dateForm.validate((valid) => {
        if (!valid) {
          return false
        }

        // 验证出发时间不能为空
        if (!this.currentDateData.departureTime) {
          this.$message.warning('请选择出发时间')
          return
        }

        // 验证价格必须大于0
        if (!this.currentDateData.price || this.currentDateData.price <= 0) {
          this.$message.warning('价格必须大于0')
          return
        }

        // 验证成团截至时间必须大于0（时间戳）
        if (
          this.currentDateData.cancelDeadline &&
          new Date(this.currentDateData.cancelDeadline).getTime() <= 0
        ) {
          this.$message.warning('成团截至时间无效')
          return
        }

        // 验证截至日期不能晚于出发日期
        if (
          this.currentDateData.cancelDeadline &&
          this.currentDateData.departureDate
        ) {
          const departureDateStr = this.currentDateData.departureDate
          const departureTimeStr =
            this.currentDateData.departureTime || '00:00:00'
          const departureDateTime = new Date(
            departureDateStr + ' ' + departureTimeStr
          ).getTime()
          const cancelDeadlineTime = new Date(
            this.currentDateData.cancelDeadline
          ).getTime()
          if (cancelDeadlineTime > departureDateTime) {
            this.$message.warning('成团截至时间不能晚于出发日期')
            return
          }
        }

        // 验证报名截止时间不能晚于出发日期
        if (
          this.currentDateData.registrationDeadline &&
          this.currentDateData.departureDate
        ) {
          const departureDateStr = this.currentDateData.departureDate
          const departureTimeStr =
            this.currentDateData.departureTime || '00:00:00'
          const departureDateTime = new Date(
            departureDateStr + ' ' + departureTimeStr
          ).getTime()
          const registrationDeadlineTime = new Date(
            this.currentDateData.registrationDeadline
          ).getTime()
          if (registrationDeadlineTime > departureDateTime) {
            this.$message.warning('报名截止时间不能晚于出发日期')
            return
          }
        }

        // 查找是否已存在
        const existingIndex = this.formData.departureList.findIndex(
          (d) => d.departureDate === this.currentDateData.departureDate
        )

        if (existingIndex >= 0) {
          // 更新已有日期
          this.$set(this.formData.departureList, existingIndex, {
            ...this.currentDateData
          })
        } else {
          // 添加新日期
          this.formData.departureList.push({ ...this.currentDateData })
        }

        this.dateDialogVisible = false
        this.generateCalendar()
        this.$message.success('日历保存成功')
      })
    },

    handleBatchImport() {
      this.batchStartDate = ''
      this.batchEndDate = ''
      this.batchDepartureTime = ''
      this.batchPrice = ''
      this.batchMinGroupSize = ''
      this.batchMaxGroupSize = ''
      this.batchCancelDeadline = ''
      this.batchRegistrationDeadline = ''
      this.batchImportVisible = true
    },

    handleBatchSave() {
      // 同步数据到 batchFormData（用于表单验证）
      this.batchFormData.startDate = this.batchStartDate
      this.batchFormData.endDate = this.batchEndDate
      this.batchFormData.departureTime = this.batchDepartureTime
      this.batchFormData.price = this.batchPrice
      this.batchFormData.minGroupSize = this.batchMinGroupSize
      this.batchFormData.maxGroupSize = this.batchMaxGroupSize
      this.batchFormData.cancelDeadline = this.batchCancelDeadline
      this.batchFormData.registrationDeadline = this.batchRegistrationDeadline

      // 使用表单验证
      this.$refs.batchForm.validate((valid) => {
        if (!valid) {
          return false
        }

        // 验证出发时间不能为空
        if (!this.batchDepartureTime) {
          this.$message.warning('请选择出发时间')
          return
        }

        // 验证价格必须大于0
        if (!this.batchPrice || this.batchPrice <= 0) {
          this.$message.warning('价格必须大于0')
          return
        }

        const start = new Date(this.batchStartDate + ' 00:00:00')
        const end = new Date(this.batchEndDate + ' 23:59:59')

        if (start > end) {
          this.$message.warning('开始日期不能晚于结束日期')
          return
        }

        // 验证截至日期不能晚于批量导入的结束日期
        if (this.batchCancelDeadline) {
          const endDateTime = new Date(
            this.batchEndDate + ' 23:59:59'
          ).getTime()
          const cancelDeadlineTime = new Date(
            this.batchCancelDeadline
          ).getTime()
          if (cancelDeadlineTime > endDateTime) {
            this.$message.warning('成团截至时间不能晚于批量导入的结束日期')
            return
          }
        }

        // 验证报名截止时间不能晚于批量导入的结束日期
        if (this.batchRegistrationDeadline) {
          const endDateTime = new Date(
            this.batchEndDate + ' 23:59:59'
          ).getTime()
          const registrationDeadlineTime = new Date(
            this.batchRegistrationDeadline
          ).getTime()
          if (registrationDeadlineTime > endDateTime) {
            this.$message.warning('报名截止时间不能晚于批量导入的结束日期')
            return
          }
        }

        // 生成日期范围内的所有日期
        const currentDate = new Date(start)
        while (currentDate <= end) {
          const dateStr = currentDate.toISOString().split('T')[0]

          // 检查是否已存在
          const existingIndex = this.formData.departureList.findIndex(
            (d) => d.departureDate === dateStr
          )

          const dateData = {
            departureDate: dateStr,
            departureTime: this.batchDepartureTime || '00:00:00', // 使用统一的出发时间
            price: this.batchPrice,
            minGroupSize: this.batchMinGroupSize,
            maxGroupSize: this.batchMaxGroupSize,
            cancelDeadline: this.batchCancelDeadline,
            registrationDeadline: this.batchRegistrationDeadline
          }

          if (existingIndex >= 0) {
            // 更新已有日期
            this.$set(this.formData.departureList, existingIndex, dateData)
          } else {
            // 添加新日期
            this.formData.departureList.push(dateData)
          }

          currentDate.setDate(currentDate.getDate() + 1)
        }

        this.batchImportVisible = false
        this.generateCalendar()
        this.$message.success(`批量添加成功，共添加了日期范围内的所有日期`)
      })
    },

    // 加载所有省份列表
    async loadProvinceList() {
      try {
        const response = await this.$http.get('/region/getAllProvinces.do')
        if (response.code === '0' || response.code === 0) {
          this.provinceList = response.result || []
        }
      } catch (error) {
        console.error('加载省份列表失败:', error)
        this.$message.error('加载省份列表失败')
      }
    },

    async loadRouteData() {
      try {
        // 调用详情接口获取线路数据
        const response = await this.$http.post('/product/getProductDetail.do', {
          productId: this.productId
        })

        if (response.code === '0' || response.code === 0) {
          const data = response.result || response.data

          // 填充表单数据
          this.formData.productName = data.productName || ''
          this.formData.difficulty = data.difficulty || ''
          this.formData.basePrice = data.basePrice || ''
          this.formData.totalDistance = data.totalDistance || ''
          this.formData.maxAltitude = data.maxAltitude || ''
          this.formData.totalDays = data.totalDays || ''
          this.formData.maxDailyHours = data.maxDailyHours || ''
          this.formData.oneWayDriveTime = data.oneWayDriveTime || ''
          this.formData.refundDays = data.refundDays || ''

          // 出发地
          this.formData.startProvince = data.startProvince || ''
          this.formData.startCity = data.startCity || ''
          this.formData.startDistrict = data.startDistrict || ''

          // 目的地
          this.formData.destProvince = data.destProvince || ''
          this.formData.destCity = data.destCity || ''
          this.formData.destDistrict = data.destDistrict || ''

          // 根据省份加载对应的城市列表
          if (this.formData.startProvince) {
            this.loadStartCityList(this.formData.startProvince)
          }
          if (this.formData.destProvince) {
            this.loadDestCityList(this.formData.destProvince)
          }

          // 文本内容
          this.formData.recommendedPeople = data.recommendedPeople || ''
          this.formData.notice = data.notice || ''
          this.formData.disclaimer = data.disclaimer || ''
          this.formData.detailContent = data.detailContent || ''

          // 解析图片列表
          if (data.imageList) {
            let imageList = []
            if (typeof data.imageList === 'string') {
              // 后端返回的可能是转义的JSON字符串
              try {
                let parsed = JSON.parse(data.imageList)
                // 如果解析后还是字符串，再次解析
                if (typeof parsed === 'string') {
                  parsed = JSON.parse(parsed)
                }
                imageList = parsed
              } catch (e) {
                console.error('解析imageList失败:', e)
                imageList = []
              }
            } else {
              imageList = data.imageList
            }

            // 转换为el-upload需要的格式（包含url、uid等）
            this.formData.imageList = imageList.map(
              (v) => v.imageUrl || v.url || v
            )
            this.imageFileList = imageList.map((v, index) => {
              return {
                uid: v.uid || Date.now() + index,
                name: v.name || `image-${index}`,
                url: v.imageUrl || v.url || '',
                imageUrl: v.imageUrl || v.url || '',
                status: 'success',
                percentage: 100,
                id: v.id,
                productId: v.productId,
                sortOrder: v.sortOrder
              }
            })
            console.log(
              '解析后的formData.imageList (URL数组):',
              this.formData.imageList
            )
            console.log(
              '解析后的imageFileList (el-upload用):',
              this.imageFileList
            )
          }

          // 解析出发日期列表
          if (data.departureList) {
            let departureList = []
            if (typeof data.departureList === 'string') {
              departureList = JSON.parse(data.departureList)
            } else {
              departureList = data.departureList
            }
            this.formData.departureList = departureList.map((v) => {
              // 将后端返回的时间戳转换为 YYYY-MM-DD 格式
              const departureDateStr = v.departureDate
                ? this.formatDateFromTimestamp(v.departureDate)
                : ''
              return {
                ...v,
                // departureDate 转换为 YYYY-MM-DD 格式
                departureDate: departureDateStr,
                // departureTime 已经是 HH:mm:ss 格式，直接使用
                departureTime: v.departureTime || '',
                // 将时间戳转换为 YYYY-MM-DD HH:mm:ss 格式
                cancelDeadline: v.cancelDeadline
                  ? this.formatTimestamp(v.cancelDeadline)
                  : '',
                registrationDeadline: v.registrationDeadline
                  ? this.formatTimestamp(v.registrationDeadline)
                  : ''
              }
            })
            console.log('departureList:', this.formData.departureList)

            // 根据 departureList 中的第一个日期定位日历
            if (this.formData.departureList.length > 0) {
              const firstDate = this.formData.departureList[0].departureDate
              const date = new Date(firstDate)
              if (!isNaN(date.getTime())) {
                this.currentYear = date.getFullYear()
                this.currentMonth = date.getMonth() + 1
              }
            }
          }

          // 重新生成日历
          this.generateCalendar()

          console.log('加载线路数据成功:', this.productId)
        } else {
          this.$message.error(response.message || '加载数据失败')
        }
      } catch (error) {
        console.error('加载线路数据错误:', error)
        this.$message.error('加载数据失败，请重试')
      }
    },

    goBack() {
      this.$router.go(-1)
    },

    handleCancel() {
      this.$confirm('确定要取消吗？未保存的内容将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$router.go(-1)
        })
        .catch(() => {})
    },

    async handleSubmit() {
      if (this.isDetail) return

      this.$refs.routeForm.validate(async (valid) => {
        if (valid) {
          try {
            const submitData = {
              ...this.formData
            }

            // 修改时需要添加id
            if (this.pageType === '2') {
              submitData.productId = this.productId
            }
            console.log('submitData:', this.formData.imageList)

            // imageList 已经是 URL 字符串数组，直接序列化
            submitData.imageList = JSON.stringify(this.formData.imageList)
            submitData.departureList = JSON.stringify(
              this.formData.departureList
            )

            const url =
              this.pageType === '1'
                ? 'product/addProduct.do'
                : 'product/updateProduct.do'

            const response = await this.$http.post(
              url,
              this.$qs.stringify(submitData),
              {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
              }
            )

            if (response.code === '0') {
              this.$message.success(
                this.pageType === '1' ? '新增成功' : '修改成功'
              )
              this.$router.go(-1)
            } else {
              this.$message.error(response.message || '操作失败')
            }
          } catch (error) {
            this.$message.error('操作失败，请重试')
            console.error(error)
          }
        } else {
          this.$message.error('请完善必填信息')
          return false
        }
      })
    },

    /**
     * 上传前校验
     * @param {Object} file - 上传的文件
     * @returns {Boolean} 是否允许上传
     */
    beforeUpload(file) {
      // 允许的文件类型：JPG、JPEG、PNG图片和MP4视频
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'video/mp4']

      console.log('=== 文件上传调试信息 ===')
      console.log('文件名:', file.name)
      console.log('文件类型:', file.type)
      console.log('文件大小:', file.size)
      console.log('上传地址:', this.uploadAction)
      console.log('参数名:', 'files')

      const isAllowedType = allowedTypes.includes(file.type)

      if (!isAllowedType) {
        this.$message.error('只支持JPG/JPEG/PNG格式图片及MP4格式视频')
        return false
      }

      // 文件大小限制：图片10MB，视频100MB
      const isImage = file.type.startsWith('image/')
      const maxSize = isImage ? 10 * 1024 * 1024 : 100 * 1024 * 1024
      const maxSizeText = isImage ? '10MB' : '100MB'

      const isWithinSize = file.size <= maxSize

      if (!isWithinSize) {
        this.$message.error(
          `${isImage ? '图片' : '视频'}大小不能超过${maxSizeText}`
        )
        return false
      }

      console.log('=== 文件校验通过，开始上传 ===')
      return true
    },

    /**
     * 点击图片预览大图
     * @param {Object} file - 点击的文件
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogFile = file // 保存完整的文件对象
      this.dialogVisible = true
    },

    /**
     * 富文本编辑器获得焦点时的处理
     */
    onEditorFocus() {
      // 立即取消焦点，防止滚动
      this.$nextTick(() => {
        const editor = document.querySelector('.ql-editor')
        if (editor) {
          editor.blur()
        }
      })
    },

    /**
     * 富文本编辑器图片上传处理
     */
    imageHandler() {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', 'image/jpeg,image/jpg,image/png')
      input.click()

      input.onchange = async () => {
        const file = input.files[0]
        if (!file) return

        // 验证文件类型和大小
        const isImage = file.type.startsWith('image/')
        if (!isImage) {
          this.$message.error('只支持JPG/JPEG/PNG格式图片')
          return
        }

        const maxSize = 10 * 1024 * 1024
        if (file.size > maxSize) {
          this.$message.error('图片大小不能超过10MB')
          return
        }

        try {
          // 调用上传接口
          const formData = new FormData()
          formData.append('files', file)

          const response = await this.$http.post(
            '/file/uploadProdImage.do',
            formData
          )

          if (response.code === '0' || response.code === 0) {
            // 获取上传成功的图片URL
            const imageUrlData =
              response.result || response.data || response.url
            let imageUrl = imageUrlData

            // 如果是JSON字符串，需要解析
            if (
              typeof imageUrlData === 'string' &&
              imageUrlData.startsWith('[')
            ) {
              try {
                const parsed = JSON.parse(imageUrlData)
                imageUrl = Array.isArray(parsed) ? parsed[0] : parsed
              } catch (e) {
                console.error('解析imageUrl失败:', e)
              }
            }

            if (imageUrl) {
              // 获取编辑器实例
              const quill = this.$refs.quillEditor.quill
              // 保存当前滚动位置
              const scrollPosition =
                window.scrollY || document.documentElement.scrollTop

              // 获取光标位置（如果没有选中位置，使用文档末尾）
              const range = quill.getSelection() || { index: quill.getLength() }
              // 插入图片
              quill.insertEmbed(range.index, 'image', imageUrl)
              // 将光标移动到图片后
              quill.setSelection(range.index + 1)

              // 恢复滚动位置并取消焦点
              setTimeout(() => {
                window.scrollTo(0, scrollPosition)
                const editor = document.querySelector('.ql-editor')
                if (editor) {
                  editor.blur()
                }
              }, 0)
            }
          } else {
            this.$message.error(response.message || '图片上传失败')
          }
        } catch (error) {
          console.error('图片上传失败:', error)
          this.$message.error('图片上传失败，请重试')
        }
      }
    },

    /**
     * 判断是否为图片文件
     * @param {Object|String} item - 文件项
     * @returns {Boolean} 是否为图片
     */
    isImageFile(item) {
      if (!item) return true

      // 如果是字符串URL，检查扩展名
      if (typeof item === 'string') {
        const ext = item.split('.').pop().toLowerCase()
        return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
      }

      const url = item.url || item.imageUrl || ''

      // 优先检查URL后缀（注意：blob: URL 没有后缀，需排除）
      if (url && !url.startsWith('blob:')) {
        const ext = url.split('.').pop().toLowerCase().split('?')[0]
        return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
      }

      const name = item.name || item.fileName || ''

      // 检查文件名后缀（name 可能是 image-0 这种无后缀的，所以放后面）
      if (name) {
        const ext = name.split('.').pop().toLowerCase()
        return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
      }

      const type = item.type || item.fileType || ''

      // 如果是文件对象，检查type
      if (type) {
        return type.startsWith('image/')
      }

      return true
    },

    /**
     * 详情页图片/视频点击预览
     * @param {Object|String} item - 图片/视频对象或URL
     */
    handleDetailImagePreview(item) {
      const url = item.imageUrl || (typeof item === 'string' ? item : item.url)
      if (url) {
        this.dialogImageUrl = url
        this.dialogFile = item
        this.dialogVisible = true
      }
    },

    /**
     * 文件状态改变回调（选择文件、上传成功/失败时触发）
     * @param {Object} file - 当前文件
     * @param {Array} fileList - 文件列表
     */
    handleImageChange(file, fileList) {
      this.imageFileList = fileList
    },

    /**
     * 图片上传成功回调
     * @param {Object} response - 上传响应数据
     * @param {Object} file - 上传的文件
     */
    handleImageSuccess(response, file) {
      if (response.code === '0' || response.code === 0) {
        // 兼容不同浏览器和Element UI版本中file.type可能丢失的情况
        const fileType = file.raw?.type || file.type || ''
        const fileName = file.name || ''
        const ext = fileName.split('.').pop().toLowerCase()
        const isImage =
          fileType.startsWith('image/') ||
          ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)

        this.$message.success(isImage ? '图片上传成功' : '视频上传成功')
        // 后端返回的可能是JSON字符串或URL字符串
        const imageUrlData = response.result || response.data || response.url
        let imageUrl = imageUrlData

        // 如果是JSON字符串（如 "[\"http://xxx.jpg\"]"），需要解析
        if (typeof imageUrlData === 'string' && imageUrlData.startsWith('[')) {
          try {
            const parsed = JSON.parse(imageUrlData)
            // 如果是数组，取第一个元素
            imageUrl = Array.isArray(parsed) ? parsed[0] : parsed
          } catch (e) {
            console.error('解析imageUrl失败:', e)
          }
        }

        if (imageUrl) {
          // 更新formData.imageList（只保存URL字符串）
          const existingIndex = this.formData.imageList.findIndex(
            (url) => url === imageUrl
          )
          if (existingIndex < 0) {
            this.formData.imageList.push(imageUrl)
          }

          // 关键修复：找到imageFileList中对应的文件对象并更新url
          // 由于el-upload内部维护了file-list，需要确保其中的file对象url被更新
          const targetFile = this.imageFileList.find((f) => f.uid === file.uid)
          if (targetFile) {
            // 直接修改对象属性，确保引用不变
            targetFile.url = imageUrl
            targetFile.imageUrl = imageUrl
            targetFile.status = 'success'
            targetFile.percentage = 100
          } else {
            // 如果没找到，创建新的文件对象
            this.imageFileList.push({
              uid: file.uid,
              name: file.name || 'image',
              url: imageUrl,
              imageUrl: imageUrl,
              status: 'success',
              percentage: 100,
              raw: file.raw
            })
          }

          console.log('上传成功 - imageUrl:', imageUrl)
          console.log('imageFileList中对应的file.url:', targetFile?.url)
          console.log('formData.imageList (URL数组):', this.formData.imageList)
        }
      } else {
        this.$message.error(response.message || '图片上传失败')
        // 上传失败，从列表中移除
        this.formData.imageList = this.formData.imageList.filter(
          (item) => item.uid !== file.uid
        )
        this.imageFileList = this.formData.imageList
      }
    },

    /**
     * 删除图片回调
     * @param {Object} file - 删除的文件
     * @param {Array} fileList - 删除后的文件列表
     */
    async handleImageRemove(file, fileList) {
      // 关键修复：先找到真实URL，再过滤列表
      let imageUrl = file.url || file.imageUrl

      // 如果 URL 是 blob 或 data 协议，说明 file.url 还是本地临时URL
      // 需要在过滤前从 imageFileList 中找到真实URL
      if (
        imageUrl &&
        (imageUrl.startsWith('blob:') || imageUrl.startsWith('data:'))
      ) {
        // 在过滤前，通过 uid 在 imageFileList 中查找对应的真实 URL
        const matchedFile = this.imageFileList.find((f) => f.uid === file.uid)
        console.log('删除操作 - blob URL检测, matchedFile:', matchedFile)

        if (
          matchedFile &&
          matchedFile.url &&
          !matchedFile.url.startsWith('blob:')
        ) {
          imageUrl = matchedFile.url
          console.log('找到匹配的真实URL:', imageUrl)
        } else {
          console.log('未能找到匹配的真实URL')
        }
      }

      console.log(
        '最终使用的 imageUrl:',
        imageUrl,
        'isBlob:',
        imageUrl && imageUrl.startsWith('blob:')
      )

      // 从 imageFileList 中移除当前文件
      this.imageFileList = (fileList || this.imageFileList).filter(
        (f) => f.uid !== file.uid
      )

      try {
        // 只有当 URL 不是 blob 或 data 协议时才进行处理
        if (
          imageUrl &&
          !imageUrl.startsWith('blob:') &&
          !imageUrl.startsWith('data:')
        ) {
          // 从 formData.imageList 中移除对应的URL
          const beforeLength = this.formData.imageList.length
          this.formData.imageList = this.formData.imageList.filter(
            (url) => url !== imageUrl
          )

          console.log(
            '删除前长度:',
            beforeLength,
            '删除后长度:',
            this.formData.imageList.length
          )

          // 调用删除接口
          const response = await this.$http.post('/file/deleteImage.do', {
            imagePath: imageUrl
          })

          if (response.code === '0' || response.code === 0) {
            this.$message.success('图片删除成功')
          } else {
            console.warn('删除接口返回错误:', response.message)
          }
        } else {
          console.log('本地文件(blob)，不需要同步到后端，仅从 imageList 移除')
        }
      } catch (error) {
        console.error('删除图片失败:', error)
        // 即使接口调用失败，也从本地列表中移除
        if (
          imageUrl &&
          !imageUrl.startsWith('blob:') &&
          !imageUrl.startsWith('data:')
        ) {
          this.formData.imageList = this.formData.imageList.filter(
            (url) => url !== imageUrl
          )
        }
      }
    },

    // 选择出发省份后加载城市列表
    async handleStartProvinceChange(provinceCode) {
      // 清空市和区
      this.formData.startCity = ''
      // this.formData.startDistrict = ''
      this.startCityList = []

      if (!provinceCode) return

      try {
        const response = await this.$http.get(
          '/region/getCitiesByProvince.do',
          {
            params: { provinceCode }
          }
        )
        if (response.code === '0' || response.code === 0) {
          this.startCityList = response.result || []
        }
      } catch (error) {
        console.error('加载出发城市列表失败:', error)
        this.$message.error('加载城市列表失败')
      }
    },

    // 加载出发城市列表（用于编辑回显）
    async loadStartCityList(provinceCode) {
      try {
        const response = await this.$http.get(
          '/region/getCitiesByProvince.do',
          {
            params: { provinceCode }
          }
        )
        if (response.code === '0' || response.code === 0) {
          this.startCityList = response.result || []
        }
      } catch (error) {
        console.error('加载出发城市列表失败:', error)
      }
    },

    // 加载目的城市列表（用于编辑回显）
    async loadDestCityList(provinceCode) {
      try {
        const response = await this.$http.get(
          '/region/getCitiesByProvince.do',
          {
            params: { provinceCode }
          }
        )
        if (response.code === '0' || response.code === 0) {
          this.destCityList = response.result || []
        }
      } catch (error) {
        console.error('加载目的城市列表失败:', error)
      }
    },

    // 选择目的地省份后加载城市列表
    async handleDestProvinceChange(provinceCode) {
      // 清空市和区
      this.formData.destCity = ''
      // this.formData.destDistrict = ''
      this.destCityList = []

      if (!provinceCode) return

      try {
        const response = await this.$http.post(
          '/region/getCitiesByProvince.do',
          {
            provinceCode
          }
        )
        if (response.code === '0' || response.code === 0) {
          this.destCityList = response.result || []
        }
      } catch (error) {
        console.error('加载目的城市列表失败:', error)
        this.$message.error('加载城市列表失败')
      }
    },

    // 选择目的城市（可后续扩展加载区）
    handleDestCityChange() {
      // this.formData.destDistrict = ''
      // TODO: 如需区的选择，可在此调用接口
    }
  }
}
</script>

<style scoped>
.route-form-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
  padding-top: 100px;
}

/* 页面头部 */
.page-header {
  position: fixed;
  top: 60px;
  left: 200px;
  right: 0px;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.header-right {
  display: flex;
  gap: 10px;
}

/* 主体内容 */
.main-content {
  display: flex;
  gap: 20px;
}

.form-section {
  flex: 1;
}

.sidebar-section {
  /* width: 320px; */
}

/* 卡片样式 */
.section-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
}

.section-title i {
  color: #166534;
}

/* 日历样式 */
.calendar-container {
  background: #f8fafc;
  border-radius: 8px;
  padding: 20px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.current-month {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.week-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-bottom: 10px;
}

.week-day {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #909399;
  padding: 10px 0;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

.calendar-day {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  min-height: 80px;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.calendar-day:hover:not(.other-month) {
  border-color: #166534;
  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);
}

.calendar-day.other-month {
  background: #f5f7fa;
  opacity: 0.5;
  cursor: default;
}

.calendar-day.has-price {
  background: #f0fdf4;
  border-color: #166534;
}

.calendar-day.past-date {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f5f7fa;
}

.calendar-day.past-date:hover {
  border-color: transparent;
  box-shadow: none;
}

.calendar-day.today {
  border-color: #409eff;
}

.day-number {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 8px;
}

.day-price {
  font-size: 12px;
  color: #f56c6c; /* 价格显示为红色 */
  font-weight: 600;
  text-align: right;
}

.day-group-info {
  font-size: 11px;
  color: #909399;
  text-align: right;
  margin-top: 2px;
}

/* 日期删除图标 */
.day-delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  background-color: rgba(245, 108, 108, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s;
}

.day-delete-icon:hover {
  background-color: rgba(245, 108, 108, 1);
  transform: scale(1.1);
}

.day-delete-icon i {
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}

.calendar-legend {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #909399;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.legend-dot.has-price {
  background: #166534;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
}

/* 表单行 */
.form-row {
  display: flex;
  gap: 20px;
}

.form-row .el-form-item {
  flex: 1;
}

/* 图片上传 */
.image-uploader {
  text-align: center;
}

.image-uploader ::v-deep .el-upload--picture-card {
  width: 147px !important;
  height: 110px !important; /* 4:3 比例 */
  line-height: 110px !important;
}

.image-uploader ::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 147px !important;
  height: 110px !important; /* 4:3 比例 */
}

.image-uploader
  ::v-deep
  .el-upload-list--picture-card
  .el-upload-list__item-thumbnail {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.image-uploader ::v-deep video.el-upload-list__item-thumbnail {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

/* 自定义删除按钮 - 右上角小图标 */
.custom-delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s;
}

.custom-delete-btn:hover {
  background-color: rgba(245, 108, 108, 0.8);
}

.custom-delete-btn i {
  color: #fff;
  font-size: 14px;
}

/* 隐藏默认的遮罩层 */
.image-uploader ::v-deep .el-upload-list__item-actions {
  display: none !important;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.preview-item {
  position: relative;
  width: 140px;
  height: 108px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  cursor: pointer;
}

/* 显示el-image的预览图标 */
.image-preview-list ::v-deep .el-image__inner {
  cursor: pointer;
}

.image-preview-list ::v-deep .el-image__preview {
  cursor: pointer;
}

.preview-video {
  width: 140px;
  height: 108px;
  border-radius: 4px;
  object-fit: cover;
  cursor: pointer;
}

.upload-tip,
.editor-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
}

/* 编辑器 */
.editor-content {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.editor-content.is-disabled {
  background-color: #f5f7fa;
}

/* 禁用富文本编辑器自动聚焦 */
.editor-content ::v-deep .ql-editor {
  outline: none;
}

/* 侧边栏 */
.sidebar-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.sidebar-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
}

.sidebar-title i {
  color: #166534;
}

/* 字段提示文字 */
.field-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

/* 响应式 */
@media (max-width: 1200px) {
  .main-content {
    flex-direction: column;
  }

  .sidebar-section {
    width: 100%;
  }
}
</style>
